import * as types from './types'
import UserResource from '@/resources/user'

const resolveClient = (data, isMain) => {
	let date = null
	if (data.user.birthdate) {
		date = data.user.birthdate
		date = date.split('-')
		date = new Date(date[2], date[1] - 1, date[0])
	}

	return {
		isMain: isMain,
		id: data.user.id,
		email: data.user.email || null,
		type: data.type || null,
		firstname: data.user.first_name || null,
		lastname: data.user.last_name || null,
		full_name: data.user.full_name || null,
		birthdate: date,
		address: {
			line: data.user.address || null,
			zip: data.user.zipcode || null,
			country: data.user.country || null,
			city: data.user.city || null
		},
		phone: data.user.phone || null,
		notes: [],
		media: {
			file: (data.user.media) ? data.user.media.file : null
		},
		lcbft_completed: data.lcbft_completed,
		lcbft_last_updated: (data.user.private_estate) ? resolveDate(data.user.private_estate.updated_at) : null,
		center_of_interest: data.user.user_tags.map(tag => tag.tags),
		source: data.source,
		rdvs: [],
		missions: [],
		certified: resolveCertified(data.user.certified),
		isFillingPatrimonialEstate: (data.user.private_estate) ? !data.user.private_estate.completed : true,
		subscription: data.subscription,
		client_next_rdv: typeof data.user.client_next_rdv !== 'undefined' ? data.user.client_next_rdv : data.next_rdv
	}
}

const resolveDate = (d) => {
	d = d.split(' ')
	d = d[0].split('/').concat(d[1].split(':'))
	return new Date(d[2], d[1] - 1, d[0], d[3], d[4])
}

const resolveCertified = (c) => {
	if (c === 0) {
		return 'NOT CERTIFIED'
	} else if (c === 1) {
		return 'CERTIFIED'
	} else if (c === 2) {
		return 'PENDING'
	}
}

export const actions = {
	login ({ commit, dispatch }, __user) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			UserResource.login(__user.email, __user.password).then((data) => {
				commit(types.LOGIN, data)
				commit(types.UPDATE_PROFILE, data.user)
				const picture = data.picture
				commit(types.PROFIL_PICTURE, { image: picture })
				commit('CLEAR_TAGS')
				data.user.office.tags.forEach((tag) => {
					commit('ADD_GENERAL_TAG', tag)
				})
			})
			.then(() => {
				dispatch('getClients')
				commit('LOADER_OUT')
				resolve()
			}).catch(() => {
				commit('LOADER_OUT')
				commit(types.LOGOUT)
				reject()
			})
		})
	},
	logout ({ commit }) {
		return new Promise((resolve, reject) => {
			UserResource.logout().then(() => {
				commit(types.LOGOUT)
				resolve()
			}).catch((error) => {
				reject(error)
			})
		})
	},
	getClients ({ commit }) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			UserResource.getClients().then((result) => {
				let clients = []
				if (result.data.main_advisor) {
					result.data.main_advisor.forEach((client) => {
						clients.push(resolveClient(client, true))
					})
				}
				if (result.data.second_advisor) {
					result.data.second_advisor.forEach((client) => {
						clients.push(resolveClient(client, false))
					})
				}
				commit(types.GET_CLIENTS, clients)
				commit('LOADER_OUT')
				resolve()
			}).catch((error) => {
				commit('LOADER_OUT')
				console.warn(error)
				reject(error)
			})
		})
	},
	getClient ({ commit, dispatch }, id) {
		let client = null
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			commit('CLEAR')
			UserResource.getClient(id).then((result) => {
				if (result.data) {
					client = resolveClient(result.data.client)
					return UserResource.fetchAppointmentsForClient(id)
				} else {
					commit('LOADER_OUT')
					reject(new Error(result.data.error))
				}
			}).then((result) => {
				if (result.data.success) {
					client.rdvs = result.data.rdvs
					return UserResource.fetchNotes(id)
				} else {
					commit('LOADER_OUT')
					reject(new Error(result.data.error))
				}
			}).then((result) => {
				if (result.data.success) {
					client.notes = result.data.notes
					return UserResource.fetchMissionsForClient(id)
				} else {
					commit('LOADER_OUT')
					reject(new Error(result.data.error))
				}
			}).then((result) => {
				if (result.data.success) {
					client.missions = result.data.missions
					if (client.certified === 'CERTIFIED') {
						commit(types.UPDATE_CLIENT, client)
						commit('LOADER_OUT')
						resolve()
					} else {
						return UserResource.getCertificateLevel(id)
					}
				} else {
					commit('LOADER_OUT')
					reject(new Error(result.data.error))
				}
			}).then((result) => {
				if (result && result.data && result.data.response && result.data.response.certificateLevel) {
					const level = result.data.response.certificateLevel
					if (level === 'certified' || level === 'advanced') {
						client.certified = 'CERTIFIED'
					}
					commit(types.UPDATE_CLIENT, client)
					commit('LOADER_OUT')
					resolve()
				}
			}).then(() => {
				// Les stats d'investissement (dont global_performance et subscription_year_perf)
				// proviennent uniquement de l'API Symfony : Django n'est plus interrogé.
				UserResource.getInvestmentStats(client.id)
					.then((resp) => {
						client.investment_stats = resp.data && resp.data.investment_stats ? resp.data.investment_stats : null
						commit(types.UPDATE_CLIENT, client)
						commit('LOADER_OUT')
						resolve()
					})
			})
			.catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	addClient ({ commit }, client) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			UserResource.addClient(client).then((result) => {
				if (result.data.success) {
					client['id'] = result.data.user.id
					commit(types.ADD_CLIENT, client)
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject(new Error(result.data.error))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	editClient ({ commit }, client) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			console.log('Start edit client action')
			UserResource.editClient(client).then((result) => {
				if (result.data.success) {
					commit(types.EDIT_CLIENT, client)
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject(new Error('Something went wrong'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	updateProfilePicture ({ commit, state }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			UserResource.updateProfilePicture(data, state.id).then((response) => {
				commit('LOADER_OUT')
				commit(types.PROFIL_PICTURE, response.data)
				resolve()
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	saveProfile ({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			UserResource.updateProfile(data).then(() => {
				commit('LOADER_OUT')
				commit(types.UPDATE_PROFILE, data)
				resolve()
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	editPassword ({ commit }, data) {
		return new Promise((resolve, reject) => {
			console.log('Received', data.getAll('current_password'))
			commit('LOADER_IN')
			UserResource.editPassword(data).then((response) => {
				commit('LOADER_OUT')
				if (response.status === 201) {
					resolve(response)
				} else {
					reject(new Error())
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	addNote ({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			UserResource.createNote({
				user_id: data.clientId,
				title: data.note.title,
				description: data.note.message
			}).then((result) => {
				commit('LOADER_OUT')
				if (result.data.success) {
					commit(types.ADD_NOTE, {
						id: data.clientId,
						note: result.data.note
					})
					resolve()
				} else {
					reject()
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	editNote ({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			UserResource.updateNote(data.note.id, {
				title: data.note.title,
				description: data.note.message
			}).then((result) => {
				if (result.data.success) {
					commit(types.UPDATE_NOTE, {
						id: data.clientId,
						note: result.data.note
					})
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject()
				}
			}).catch((error) => {
				reject(error)
			})
		})
	},
	deleteNote ({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			UserResource.deleteNote(data.note.id).then((result) => {
				if (result.data.success) {
					commit(types.DELETE_NOTE, data)
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_IN')
					reject()
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	sendLCBCFT ({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			UserResource.postLCBCFT(data).then((result) => {
				if (result.data.success) {
					commit(types.ADD_LCBCFT_TO_CLIENT, data.user_id)
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	sendMailCheckPaysage ({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			UserResource.postCheckPaysage(data).then((result) => {
				if (result.data.success) {
					commit(types.ADD_CHECK_PAYSAGE, data.user_id)
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},

	setAvailable ({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			UserResource.setAvailable(data).then((result) => {
				if (result.data.success) {
					commit(types.SET_AVAILABLE, { available: (result.data.available !== 0), ooo_message: data.ooo_message })
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	createAppointment ({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			UserResource.createAppointment(data).then((result) => {
				if (result.data.success) {
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject()
				}
			}).catch((error) => {
				console.warn(error)
				commit('LOADER_OUT')
				reject()
			})
		})
	},
	updateAppointment ({ commit }, { id, data }) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			UserResource.updateAppointment(id, data).then((result) => {
				if (result.data.success) {
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject()
				}
			}).catch((error) => {
				console.warn(error)
				commit('LOADER_OUT')
				reject()
			})
		})
	},
	removeAppointment ({ commit }, id) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			UserResource.deleteAppointment(id).then((result) => {
				if (result.data.success) {
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject()
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	getClientInvestmentStats ({ commit }, id) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			UserResource.getInvestmentStats(id)
				.then((response) => {
					commit('LOADER_OUT')
					resolve(response.data.investment_stats)
				}).catch(() => {
					commit('LOADER_OUT')
					reject()
				})
		})
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/Users/actions.js